import { createFileRoute } from "@tanstack/react-router";
import { revenueSearchSchema } from "../-lib/search-schema";



export const Route = createFileRoute("/_protected/goals/revenue/")({
  head: () => ({
    meta: [{ title: "营收管理 · imiker CRM" }],
  }),
  validateSearch: revenueSearchSchema
});
